export const NEW_TYPES = [
  { value: "NEWS", label: "Tin tức" },
  { value: "EVENT", label: "Sự kiện" },
  { value: "GUID", label: "Hướng dẫn" },
];
